/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Введение</h2>
    <p className={styles.description}>При использовании библиотеки Redux есть три основные проблемы. </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Сложный процесс настройки Redux-хранилища</li>
      <li className={styles.list__item}>Необходимость добавлять стандартный набор дополнительных пакетов</li>
      <li className={styles.list__item}>Большой объем бойлерплейт кода</li>
    </ul>
    <p className={styles.description}>
      <a className={styles.link} href="https://redux-toolkit.js.org/" target="_blank">
        Redux Toolkit
      </a>{' '}
      это официальная библиотека для эффективной разработки с использованием Redux, которая предназначена для
      стандартизации написания Redux-логики.
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Позволяет сосредоточиться на написании основной логики приложения, не тратя время на настройку.
      </li>
      <li className={styles.list__item}>
        Включает в себя утилиты для упрощения основных задач. Таких как настройка хранилища, создание редюсеров,
        иммутабельное обновление данных и многое другое.
      </li>
      <li className={styles.list__item}>
        Предоставляет стандартный набор настроек для хранилища и включает в себя наиболее часто используемые дополнения
        из Redux-экосистемы.
      </li>
    </ul>
    <p className={styles.description}>
      Библиотека не предназначена для решения всех возможных проблем и намеренно ограничена в объеме. Такие решения как
      HTTP-запросы, структура папок и файлов, управление связями сущностей в хранилище и т. д. ложаться на плечи
      разработчика. Тем не менее, Redux Toolkit будет полезен для всех стандартных задач, поможет упростить и улучшить
      Redux-код.{' '}
    </p>
    <p className={styles.description}>
      <a className={styles.link} href="https://redux-toolkit.js.org/" target="_blank">
        Документация Redux Toolkit
      </a>
    </p>
  </section>
))
